import {
  FETCH_BILLING_PLANS,
  FETCH_BILLING_PLANS_SUCCESS,
  FETCH_BILLING_PLANS_FAILURE,
  START_BILLING_CHECKOUT,
  START_BILLING_CHECKOUT_SUCCESS,
  START_BILLING_CHECKOUT_FAILURE,
  CONFIRM_BILLING_CHECKOUT,
  CONFIRM_BILLING_CHECKOUT_SUCCESS,
  CONFIRM_BILLING_CHECKOUT_FAILURE,
  CHANGE_BILLING_PLAN,
  CHANGE_BILLING_PLAN_SUCCESS,
  CHANGE_BILLING_PLAN_FAILURE,
  PREVIEW_BILLING_PLAN_CHANGE,
  PREVIEW_BILLING_PLAN_CHANGE_SUCCESS,
  PREVIEW_BILLING_PLAN_CHANGE_FAILURE,
  CLEAR_BILLING_PLAN_PREVIEW,
  CANCEL_BILLING,
  CANCEL_BILLING_SUCCESS,
  CANCEL_BILLING_FAILURE,
  UPDATE_BILLING_QUANTITY,
  UPDATE_BILLING_QUANTITY_SUCCESS,
  UPDATE_BILLING_QUANTITY_FAILURE,
} from "./constants";

export const fetchBillingPlans = (payload) => ({
  type: FETCH_BILLING_PLANS,
  payload,
});
export const fetchBillingPlansSuccess = (payload) => ({
  type: FETCH_BILLING_PLANS_SUCCESS,
  payload,
});
export const fetchBillingPlansFailure = (payload) => ({
  type: FETCH_BILLING_PLANS_FAILURE,
  payload,
});

export const startBillingCheckout = (payload) => ({
  type: START_BILLING_CHECKOUT,
  payload,
});
export const startBillingCheckoutSuccess = (payload) => ({
  type: START_BILLING_CHECKOUT_SUCCESS,
  payload,
});
export const startBillingCheckoutFailure = (payload) => ({
  type: START_BILLING_CHECKOUT_FAILURE,
  payload,
});

export const confirmBillingCheckout = (payload) => ({
  type: CONFIRM_BILLING_CHECKOUT,
  payload,
});
export const confirmBillingCheckoutSuccess = (payload) => ({
  type: CONFIRM_BILLING_CHECKOUT_SUCCESS,
  payload,
});
export const confirmBillingCheckoutFailure = (payload) => ({
  type: CONFIRM_BILLING_CHECKOUT_FAILURE,
  payload,
});

export const changeBillingPlan = (payload) => ({
  type: CHANGE_BILLING_PLAN,
  payload,
});
export const changeBillingPlanSuccess = (payload) => ({
  type: CHANGE_BILLING_PLAN_SUCCESS,
  payload,
});
export const changeBillingPlanFailure = (payload) => ({
  type: CHANGE_BILLING_PLAN_FAILURE,
  payload,
});
export const previewBillingPlanChange = (payload) => ({
  type: PREVIEW_BILLING_PLAN_CHANGE,
  payload,
});
export const previewBillingPlanChangeSuccess = (payload) => ({
  type: PREVIEW_BILLING_PLAN_CHANGE_SUCCESS,
  payload,
});
export const previewBillingPlanChangeFailure = (payload) => ({
  type: PREVIEW_BILLING_PLAN_CHANGE_FAILURE,
  payload,
});
export const clearBillingPlanPreview = () => ({
  type: CLEAR_BILLING_PLAN_PREVIEW,
});

export const cancelBilling = (payload) => ({
  type: CANCEL_BILLING,
  payload,
});
export const cancelBillingSuccess = (payload) => ({
  type: CANCEL_BILLING_SUCCESS,
  payload,
});
export const cancelBillingFailure = (payload) => ({
  type: CANCEL_BILLING_FAILURE,
  payload,
});

export const updateBillingQuantity = (payload) => ({
  type: UPDATE_BILLING_QUANTITY,
  payload,
});
export const updateBillingQuantitySuccess = (payload) => ({
  type: UPDATE_BILLING_QUANTITY_SUCCESS,
  payload,
});
export const updateBillingQuantityFailure = (payload) => ({
  type: UPDATE_BILLING_QUANTITY_FAILURE,
  payload,
});
